module.exports = __webpack_public_path__ + "img/HERBORIST-icon.0df88afd.png";